export type TeamMember = {
  id: number;
  name: string;
  position: string;
  image: string;
};
export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "Aydin",
    position: "Döner- und Grillmeister",
    image: "/sl_team1.jpeg",
  },
  {
    id: 2,
    name: "Yakup",
    position: "Imbiss-Fachmann",
    image: "/sl_team2.jpeg",
  },
];
